import i18n, { initI18n } from '@/lib/i18n/config';
import { getCadrinoCopy } from '@/lib/cadrino-landing/copy';
import type { AppLanguage } from './constants';
import { normalizeLanguage } from './constants';
import { getLandingLanguage } from './landing-language-storage';

export function syncLandingDocumentMeta(lang?: AppLanguage): void {
  if (typeof document === 'undefined') {
    return;
  }
  const lng = normalizeLanguage(lang ?? i18n.language ?? getLandingLanguage());
  if (!i18n.isInitialized) {
    initI18n(lng);
  }
  const copy = getCadrinoCopy(lng);
  document.documentElement.lang = lng;
  document.title = copy.meta.title;
  const meta = document.querySelector('meta[name="description"]');
  if (meta) {
    meta.setAttribute('content', copy.meta.description);
  }
}
